import { createReduxActionTypes } from '../../../utils/actionFactory';

const OPEN_DIALOG = 'OPEN_DIALOG';
const CLOSE_DIALOG = 'CLOSE_DIALOG';
const SET_ERROR = 'SET_ERROR';

export const actionTypes = createReduxActionTypes('OTP_CODE', [
  OPEN_DIALOG,
  CLOSE_DIALOG,
  SET_ERROR
]);

const DEFAULT_STATE = {
  open: false,
  login: '',
  password: '',
  error: null
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[OPEN_DIALOG]: {
      const { login, password, error } = action;

      return {
        ...state,
        open: true,
        login,
        password,
        error: error || null
      };
    }
    case actionTypes[SET_ERROR]: {
      return {
        ...state,
        error: action.error
      };
    }
    case actionTypes[CLOSE_DIALOG]: {
      return { ...DEFAULT_STATE };
    }
    default:
      return state;
  }
};

export const actions = {
  openDialog: ({ login, password, error }) => ({
    type: actionTypes[OPEN_DIALOG],
    login,
    password,
    error
  }),
  setError: error => ({
    type: actionTypes[SET_ERROR],
    error
  }),
  closeDialog: () => ({ type: actionTypes[CLOSE_DIALOG] })
};
